import * as React from 'react';
import { useRef } from 'react';
import { CustomerNotification } from '@shared-ui/customer-notifications';
import { NotificationLocation } from '__generated__/api/types';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { classNames } from 'uitk-react-utils';
import { useStores } from 'utility/hooks';
import { removeClasses } from 'utility/class-list-utils';

interface CustomerNotificationsProps {
  location: NotificationLocation;
  classes?: string;
}
export const CustomerNotifications = ({ location, classes }: CustomerNotificationsProps) => {
  const { gaiaIdStore } = useStores();
  const { page } = useStores();
  const customerNotificationsClasses = classNames({ [classes]: classes });
  const ref = useRef<HTMLDivElement>(null);

  const actionCallback = () =>
    customerNotificationsClasses && ref.current && removeClasses(ref.current.classList, customerNotificationsClasses);

  const customerNotificationInputs = {
    notificationLocation: location,
    xPageId: page.pageId
  };
  const regionId = gaiaIdStore && gaiaIdStore.gaiaId;
  if (regionId) {
    customerNotificationInputs['optionalContext'] = { regionId };
  }

  return (
    <Experiment name="Fshop_Travel_Advisory">
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <div data-test-id="customer-notifications" ref={ref} className={customerNotificationsClasses}>
          <CustomerNotification inputs={customerNotificationInputs} actionCallback={actionCallback} />
        </div>
      </ExperimentVariant>
    </Experiment>
  );
};
